import { router } from 'expo-router';
import {
    BulletPoint,
    Button,
    ButtonSize,
    ButtonVariant,
    CircleNumberOneIcon,
    CircleNumberThreeIcon,
    CircleNumberTwoIcon,
    H5Emphasized,
    ScreenContainer,
    YStack,
} from 'smoothie';

const AddToAppleWallet = () => {
    return (
        <ScreenContainer hasBackButton onFallbackRoute="/home/banking">
            <YStack justifyContent="space-between">
                <YStack>
                    <H5Emphasized>
                        Add your Fruitful Card to Apple Wallet
                    </H5Emphasized>
                    <BulletPoint
                        icon={CircleNumberOneIcon}
                        text="Open the Apple Wallet app on your iPhone"
                    />
                    <BulletPoint
                        icon={CircleNumberTwoIcon}
                        text={`Click the "add" button in the top right`}
                    />
                    <BulletPoint
                        icon={CircleNumberThreeIcon}
                        text="Grab your card number and CVV and enter those into the Apple Wallet app."
                    />
                </YStack>
                <Button
                    variant={ButtonVariant.PRIMARY}
                    size={ButtonSize.LARGE}
                    text="Done"
                    onPress={() => {
                        if (router.canGoBack()) {
                            router.back();
                        } else {
                            router.navigate('/home/banking');
                        }
                    }}
                    buttonProps={{ marginTop: 'auto' }}
                />
            </YStack>
        </ScreenContainer>
    );
};

export default AddToAppleWallet;
